/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PathInput
 */
export interface PathInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof PathInput
     */
    input: Array<string>;
}

export function PathInputFromJSON(json: any): PathInput {
    return PathInputFromJSONTyped(json, false);
}

export function PathInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): PathInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'input': json['input'],
    };
}

export function PathInputToJSON(value?: PathInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'input': value.input,
    };
}


